var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { connect } from "@irati/store";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import id from "@irati/utils/id";
import { H4 } from "@irati/ui/src/Headings";
import { ButtonLink } from "@irati/ui/src/Link";
import ExpandingList from "@irati/ui/src/ExpandingList";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
import Flex from "@irati/ui/src/Flex";
import { TabTypes } from "../../containers/Wallet/Wallet";
import { ExtraPaddingCard, TopHr, BottomHr } from "./styled";
var FAQs = function (_a) {
    var isMobile = _a.isMobile, formatMessage = _a.formatMessage, selectedTab = _a.selectedTab, props = __rest(_a, ["isMobile", "formatMessage", "selectedTab"]);
    var idNamespace = id("faqs", props);
    var listItems = function () {
        if (selectedTab === TabTypes.Cancelled) {
            return [
                {
                    title: formatMessage({ id: "wallet.faqs.q1.cancelledTransactionQuestion" }),
                    description: formatMessage({ id: "wallet.faqs.q1.cancelledTransactionAnswer" })
                }
            ];
        }
        return [
            {
                title: formatMessage({ id: "wallet.faqs.q1.question" }),
                description: formatMessage({ id: "wallet.faqs.q1.answer" })
            },
            {
                title: formatMessage({ id: "wallet.faqs.q2.question" }),
                description: formatMessage({ id: "wallet.faqs.q2.answer" })
            }
        ];
    };
    return (React.createElement(ExtraPaddingCard, { id: idNamespace, small: true },
        React.createElement(H4, null,
            React.createElement(FormattedMessage, { id: "wallet.faqs.title" })),
        React.createElement(TopHr, null),
        React.createElement(ExpandingList, { id: id("faq-expanding-list", props), items: listItems() }),
        React.createElement(BottomHr, null),
        React.createElement(ButtonLink, { tertiary: true, cta: true, id: id("read-full-faqs", idNamespace), full: isMobile, href: formatMessage({ id: "wallet.faqs.button.href" }), target: "_blank" },
            React.createElement(Flex, null,
                React.createElement(FormattedMessage, { id: "wallet.faqs.button.text" }),
                React.createElement(Icon, { icon: IconTypes.arrowRight, marginLeft: true })))));
};
FAQs.propTypes = {
    isMobile: PropTypes.bool.isRequired,
    formatMessage: PropTypes.func.isRequired
};
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return ({
        isMobile: get(mq, "lessThan.medium", false)
    });
};
export default injectIntl(connect(mapStateToProps)(FAQs));
